/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */
import { useFormContext } from 'react-hook-form';

import { translate } from '@utils/translations';

import { IAttributeFieldProps } from './types';
import * as S from './styles';

const extractDisplayName = (name: string): string => name.split('-').pop();

export const AttributeFieldPill: React.FC<IAttributeFieldProps> = ({
  attribute,
}) => {
  const { register } = useFormContext();

  return (
    <S.Pill>
      {attribute.values.map((value) => (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label key={value.id}>
          <input
            type="radio"
            name={attribute.attribute.slug}
            value={value.slug}
            {...register(attribute.attribute.slug)}
          />
          <div>
            <span>{extractDisplayName(translate(value, 'name'))}</span>
          </div>
        </label>
      ))}
    </S.Pill>
  );
};
